<template>
  <div class="contract-header">
    <div class="pink-overlay">
      <img v-if="isFetched"
           :src="agencyImagePath"
           class="agency-image" />
    </div>
    <ul class="contract-details">
      <li>
        <i class="circle" :class="classDependingOnContractStatus"></i>{{contract.decoded_type}}</li>
      <li>{{contract.organization_display_name}}</li>
      <li>{{agency.street_line1}} {{agency.zipcode}} {{agency.city}}</li>
      <li>Type : {{contract.decoded_domiciliation_type}}</li>
      <!-- <li>N° : 293994404 ??</li> -->
    </ul>
  </div>
</template>
<script>
  import contractsMixin from 'mixins/contracts'
  import { mapState, mapActions } from "vuex"
  export default {

    name: "ContractHeader",

    props: ["contract"],

    data () {
      return {

      }
    },

    mixins: [contractsMixin],

    computed: {
      ...mapState("contract", ["fullOffers"]),

      agency () {
        return !_.isEmpty(this.contract) &&
          this.contract.offer.distributed_product.agency
      },

      isFetched () {
        return this.contract && _.has(this.contract, 'offer.id') && _.find(this.fullOffers, (offer) => offer.id === this.contract.offer.id)
      },

      agencyImagePath () {
        var offer = _.find(this.fullOffers, (offer) => offer.id == this.contract.offer.id)
        if (offer != undefined) {
          var img = _.find(offer.distributed_product.agency.images, (image) => image.order_column == 1)
          if (img != undefined)
            return __API_URL__ + "/photos/" + img.id + "/" + img.file_name
        }
      },

      classDependingOnContractStatus () {
          switch (this.contract.status) {
              case 'active':
                return 'green'
                break
              case 'terminated':
                return 'red'
                break
              case 'pending-startup':
                return 'blue'
                break
              case 'pending-termination':
                return 'orange'
                break
          }
      }

    },

    methods: {

    }
  }
</script>
<style lang="scss" scoped>
  div.pink-overlay {
    flex: 1;
    width: 100%;
    height: 100%;
  }

  .contract-header {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .contract-header div {
    position: relative;
  }

  .contract-details {
    position: absolute;
    font-size: 1rem;
    color: #Fff;
    right: 100px;
    list-style-type: none;
    li {
      &:first-child {
        font-size: 1.2rem;
      }
      &:nth-child(2) {
        font-size: 1.2rem;
        text-transform: uppercase;
      }
    }
  }

  img.agency-image {
    object-fit: cover;
    width: 100%;
    height: 100%;
    display: block;
  }

  div.pink-overlay:after,
  {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to right, rgba(251, 85, 122, 0.3) 0%, rgba(251, 85, 122, 0.8) 60%, rgba(251, 85, 122, 0.9) 100%);
    opacity: .6;
  }
</style>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/ContractHeader.vue